import { hideCurrentModal } from '../../globalState'
import { ChatSizeField } from '../../optionsGuiScheme'
import { SettingsScreen } from './SettingsUi'

export const ChatScreen = ({ canGoBack }: { canGoBack?: boolean }) => (
  <SettingsScreen title='Чат' onBack={canGoBack ? hideCurrentModal : undefined}>
    <ChatSizeField />
  </SettingsScreen>
)
